/* AUTH HANDLER */
export const isAuthGuardActive = true;

export const UserRole = {
  superadmin: 'superadmin',
  promoter: 'promoter',
  admin: 'admin',
  user: 'user',
};

export const homeMenuItems = [
  { label: 'HOME', link: '/' },
  { label: 'REFUND POLICY', link: '/refund-policy' },
  { label: 'TERMS & CONDITION', link: '/terms-and-condition' },
  { label: 'PRIVACY POLICY', link: '/privacy-policy' },
  { label: 'CONTACT US', link: '/contact-us' },
  { label: 'ABOUT US', link: '/about-us' },
  { label: 'REGISTER', link: '/user/register' },
  { label: 'SIGN IN', link: '/app' },
];

export const ENVIRONMENT = {
  production: 'production',
  staging: 'staging',
  local: 'local',
};
/* AUTH HANDLER */

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.admin,
};

export const adminRoot = '/app';
export const loginRoot = '/user/login';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
